"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _default(_ref) {
  var width = _ref.width,
    height = _ref.height,
    color = _ref.color,
    rotate = _ref.rotate,
    className = _ref.className,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'icon' : _ref$dataTestid;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " icon icon--navigation fill-").concat(color),
    style: {
      width: "".concat(width, "px"),
      transform: "rotate(".concat(rotate, "deg)"),
      height: "".concat(height, "px")
    },
    viewBox: "0 0 24 24",
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M11.056 12.47L5.293 6.707a1 1 0 011.414-1.414l5.763 5.763a1 1 0 11-1.414 1.414zm6.237 6.237l-3.473-3.473a1 1 0 111.414-1.414l3.473 3.473a1 1 0 11-1.414 1.414z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M10.773 12.753L5.01 6.99a1.4 1.4 0 111.98-1.98l5.763 5.763a1.4 1.4 0 01-1.98 1.98zm6.237 6.237l-3.473-3.473a1.4 1.4 0 011.98-1.98l3.473 3.473a1.4 1.4 0 01-1.98 1.98zM5.293 6.707l5.763 5.763a1 1 0 101.414-1.414L6.707 5.293a1 1 0 00-1.414 1.414zm8.527 8.527l3.473 3.473a1 1 0 101.414-1.414l-3.473-3.473a1 1 0 10-1.414 1.414z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.707 18.707l12-12a1 1 0 10-1.414-1.414l-12 12a1 1 0 101.414 1.414z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M18.99 6.99l-12 12a1.4 1.4 0 01-1.98-1.98l12-12a1.4 1.4 0 111.98 1.98zm-.283-.283l-12 12a1 1 0 11-1.414-1.414l12-12a1 1 0 111.414 1.414z",
    clipRule: "evenodd"
  })));
}